export const Colors = {
    borderNavColor:
        'border-primary/20 dark:border-secondary/15'
    ,
}